const ReviewActions = {
    UPDATE: 'UPDATE_REVIEWS',
}

export default ReviewActions;